import { axiosInstance } from "./axiosInstance";

export const signupMember = async (data: any) => {
    try {
        const response = await axiosInstance.post(`/api/members/signup`, data);
        return response.data;
    } catch (error) {
        console.error("회원가입 에러:", error);
        throw error;
    }
};

export const loginMember = async (data: any) => {
    try {
        const response = await axiosInstance.post(`/api/members/login`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 💡 내 정보(로그인 상태) 확인 API
export const getMyInfo = async () => {
    try {
        const response = await axiosInstance.get(`/api/members/me`);
        return response.data; // ApiResponse 객체를 반환

    } catch (error) {
        console.error("내 정보 조회 에러:", error);
        return null;
    }
};

// 💡 로그아웃 API
export const logoutMember = async () => {
    try {
        const response = await axiosInstance.post(`/api/members/logout`);
        return response.data;
    } catch (error) {
        console.error("로그아웃 에러:", error);
        throw error;
    }
};

// 💡 아이디 중복 확인 API (새로 추가된 부분)
export const checkDuplicateId = async (loginId: string) => {
    try {
        // 백엔드 REST API 설계에 맞춰 Query Parameter로 전달
        const response = await axiosInstance.get(`/api/members/check-id`, {
            params: { loginId }
        });

        // 백엔드 응답 구조에 맞게 boolean 값 반환
        // (예: response.data.data.isAvailable 또는 response.data 등)
        return response.data.data;
    } catch (error) {
        console.error("아이디 중복 확인 에러:", error);
        throw error;
    }
};

// 💡 아이디 찾기 API
export const findLoginId = async (data: { memberName: string, email: string }) => {
    try {
        const response = await axiosInstance.post(`/api/members/find-id`, data);
        return response.data.data; // 마스킹된 아이디 반환
    } catch (error) {
        throw error;
    }
};

// 💡 비밀번호 찾기(임시 발급) API
export const resetPassword = async (data: { loginId: string, email: string }) => {
    try {
        const response = await axiosInstance.post(`/api/members/reset-password`, data);
        return response.data.data; // 임시 비밀번호 반환
    } catch (error) {
        throw error;
    }
};

// 💡 회원정보 수정 (이름, 휴대폰, 비밀번호 변경)
export const updateMemberInfo = async (data: { memberName?: string; phone?: string; password?: string }) => {
    try {
        if (!data.password) delete data.password;
        const response = await axiosInstance.put(`/api/members/me`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};